module.exports = __webpack_public_path__ + "images/emoji/tiger2.a89a4bc105453f30b2ee.png";